import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard, Building2, Package, Tag, LogOut, Bell, Search,
} from "lucide-react";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-admin-dashboard" },
  { to: "/admin/tenants", label: "Tenants", icon: Building2, testid: "nav-admin-tenants" },
  { to: "/admin/plans", label: "Plans", icon: Package, testid: "nav-admin-plans" },
  { to: "/admin/coupons", label: "Coupons", icon: Tag, testid: "nav-admin-coupons" },
];

export default function AdminShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid="admin-shell" className="flex min-h-screen bg-zinc-100">
      <aside className="w-64 bg-asphalt text-white flex flex-col">
        <div className="px-5 h-16 flex items-center gap-2 border-b border-zinc-800">
          <span className="h-8 w-8 bg-cab flex items-center justify-center rounded font-display font-black text-asphalt">W</span>
          <div>
            <div className="font-display font-bold text-sm">WebCabz</div>
            <div className="text-[10px] uppercase tracking-widest text-cab">Super Admin</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} data-testid={testid} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
              <Icon /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-zinc-800">
          <button
            data-testid="admin-logout"
            onClick={async () => { await logout(); navigate("/login"); }}
            className="sidebar-link w-full"
          >
            <LogOut /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col">
        <header className="h-16 bg-white border-b border-zinc-200 px-6 flex items-center justify-between">
          <div className="flex items-center gap-3 text-zinc-500">
            <Search className="h-4 w-4" />
            <input placeholder="Search tenants, plans, payments…" className="bg-transparent text-sm outline-none w-80" />
          </div>
          <div className="flex items-center gap-4">
            <button className="text-zinc-500 relative">
              <Bell className="h-4 w-4" />
              <span className="absolute -top-0.5 -right-1 h-2 w-2 rounded-full bg-cab" />
            </button>
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-full bg-asphalt text-cab flex items-center justify-center font-display font-bold text-sm">
                {(user?.name || "A").charAt(0)}
              </div>
              <div className="text-xs">
                <div className="font-semibold text-asphalt">{user?.name}</div>
                <div className="text-zinc-500">{user?.email}</div>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 p-6 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
